import { render, staticRenderFns } from "./MyloadSwipeItem.vue?vue&type=template&id=295b86b8&scoped=true"
import script from "./MyloadSwipeItem.vue?vue&type=script&lang=js"
export * from "./MyloadSwipeItem.vue?vue&type=script&lang=js"
import style0 from "./MyloadSwipeItem.vue?vue&type=style&index=0&id=295b86b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b86b8",
  null
  
)

export default component.exports